import { z } from "zod";

import { deliverableTypeSchema, expressionTypeSchema } from "./enums";
import { conditionalSchema } from "./conditional";
import { assignmentExpressionSchema } from "./assignment-expression";

export const extractValueConfigurationSchema = z.object({
	target: z.string(),
	valueExpression: z.string(),
	expressionType: expressionTypeSchema.optional(),
	conditional: conditionalSchema.optional(),
	sourceContext: deliverableTypeSchema,
	assignmentExpressions: z.array(assignmentExpressionSchema).nullish(),
});
export type ExtractValueConfiguration = z.infer<typeof extractValueConfigurationSchema>;
